import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.2462 1.92925C11.5706 1.60478 11.5706 1.07872 11.2462 0.754248C10.9217 0.429781 10.3956 0.429781 10.0712 0.754248L6.00033 4.82508L1.92949 0.754248C1.60502 0.429781 1.07896 0.429781 0.754492 0.754248C0.430025 1.07872 0.430025 1.60478 0.754492 1.92925L4.82533 6.00008L0.754492 10.0709C0.430025 10.3954 0.430025 10.9214 0.754492 11.2459C1.07896 11.5704 1.60502 11.5704 1.92949 11.2459L6.00033 7.17508L10.0712 11.2459C10.3956 11.5704 10.9217 11.5704 11.2462 11.2459C11.5706 10.9214 11.5706 10.3954 11.2462 10.0709L7.17533 6.00008L11.2462 1.92925Z" }, null, -1)
  ]))]))
}
export default { render: render }